export default __webpack_public_path__ + "static/media/36.69b722f7.svg";